// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2KdJ0","inner":"Footer_inner__2qb3e"};